import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import { Input } from '@app/components/common/inputs/Input/Input';
import { IMessage } from '@app/interfaces/message';
import { Modal } from 'antd';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './../ChatView.styles';
import { getRawMessage, getReadableFileName } from '@app/utils/utils';
import { openFile } from '@app/utils/file';
import { IFile } from '@app/interfaces/file';
import { UserOutlined } from '@ant-design/icons';

interface EditChatMessageProps {
  open: boolean;
  loading: boolean;
  selectedChat: IMessage;
  onCancel: () => void;
  onEditChat: (values: { message: string }) => void;
}

export const EditChatMessage: React.FC<EditChatMessageProps> = ({
  open,
  selectedChat,
  loading,
  onCancel,
  onEditChat,
}) => {
  const [form] = BaseForm.useForm();
  const { t } = useTranslation();

  const chatFormValues = useMemo(
    () => ({
      message: selectedChat?.message || '',
    }),
    [selectedChat],
  );

  const onOk = () => {
    form.submit();
  };

  return (
    <Modal
      title={t('chats.editMessage')}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText={t('common.save')}
      cancelText={t('common.cancel')}
      confirmLoading={loading}
    >
      <S.PreviewMessageContent>
        <S.MessageBubble isOwn={selectedChat.isOwn} className="preview">
          {selectedChat.file && (
            <S.Message>
              <a onClick={() => openFile(selectedChat.file as IFile)}>
                {getReadableFileName(selectedChat.file.originalName as string)}
              </a>
            </S.Message>
          )}
          {selectedChat.link && (
            <S.Message>
              <a href={selectedChat.link} target="_blank" rel="noreferrer">
                {getReadableFileName(selectedChat.link)}
              </a>
            </S.Message>
          )}
          <S.Message dangerouslySetInnerHTML={getRawMessage(selectedChat.message)} dir={selectedChat.dir} />
          <S.Time>
            {selectedChat.isSentAdmin && <UserOutlined />}
            {selectedChat.createdAt}
          </S.Time>
        </S.MessageBubble>
      </S.PreviewMessageContent>
      <BaseForm initialValues={chatFormValues} form={form} layout="vertical" name="noteForm" onFinish={onEditChat}>
        <BaseForm.Item
          name="message"
          label={t('chats.message')}
          rules={[{ required: true, message: t('chats.messageRequired') }]}
        >
          <Input />
        </BaseForm.Item>
      </BaseForm>
    </Modal>
  );
};
